module.exports = __webpack_public_path__ + "static/Image_Asset_3-d2e5f2856495e1a7210b5e59100e4992.png";